// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"5bc86716","563":"6bbcbc5b"}[chunkId] + ".chunk.js";
};